import "bootstrap-icons/font/bootstrap-icons.css";
import "./Franchises.css";
import { useState } from "react";
import { Table } from "antd";
import { useEffect } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import ViewBtn from "../../Buttons/ViewBtn";
import UserPrivateComponent from "../../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../../UI/CsvLinkBtn";
import { NavLink } from "react-router-dom";
import { AiFillDelete, AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import CrmSearch from "../../CRM/CommonUi/CrmSearch";
import ConfirmModal from "../../ConfirmationModal/ConfirmModal";
import downloadLogo from "../../../assets/images/download-logo.svg";
import { deleteFranchise, getAllFranchises } from "../../../redux/rtk/features/franchise/franchiseSlice";
function CustomTable({ list }) {
  const dispatch = useDispatch();
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [filteredList, setFilteredList] = useState(list);
  const { isFetchingFranchises, isDeleting } = useSelector((state) => state.franchise);

  useEffect(() => {
    setFilteredList(list)
  }, [list])

  const deleteHandler = async (id) => {
    try {
      const res = await dispatch(deleteFranchise(id)).unwrap()
      dispatch(getAllFranchises({ status: true, page: 1, count: 10 }))
    } catch (error) {
      console.error(error)
    }
  }

  // Modal

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [franchiseToDelete, setFranchiseToDelete] = useState(null);

  const handleOk = async () => {
    try {
      await deleteHandler(franchiseToDelete);
      setIsModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFranchiseToDelete(null);
  };

  // columns
  const columns = [
    {
      id: 1,
      title: "No",
      dataIndex: "id",
      key: "id",
    },
    {
      id: 2,
      title: "Franchise Name",
      dataIndex: "franchiseName",
      key: "franchiseName",
      // render: ({ firstName, lastName }) =>
      //   (firstName + " " + lastName).toUpperCase(),
    },
    {
      id: 3,
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      id: 4,
      title: "Status",
      dataIndex: "franchiseStatus",
      key: "franchiseStatus",
    },
    {
      id: 5,
      title: "Franchise Owner",
      dataIndex: "ownerName",
      key: "ownerName",
      // render: (record) =>
      //   record.length > 0 ? record[0].designation.name : "N/A",
    },

    // TODO: fix this column to show the correct data

    {
      id: 6,
      title: "Location",
      dataIndex: "location",
      key: "location",
      // render: (record) => (record?.name ? record?.name : "N/A"),
    },
    {
      id: 8,
      title: "Support Email",
      dataIndex: "email",
      key: "email",
      // render: (record) => (record?.name ? record?.name : "N/A"),
    },

    {
      id: 9,
      title: "Support Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      // render: (record) => (record?.name ? record?.name : "N/A"),
    },

    {
      id: 7,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id) => (
        <div className='flex justify-start'>
          <UserPrivateComponent permission={"readSingle-user"}>
            <ViewBtn path={`/admin/franchise/update/${id}/`} />
          </UserPrivateComponent>
          <span
            onClick={() => {
              setIsModalOpen(true);
              setFranchiseToDelete(id)
            }}
            className='text-[#EF4444] text-lg font-bold p-1 rounded mr-2 cursor-pointer inline-flex items-center justify-center'
          >
            <AiFillDelete />
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  // filter
  const [isFilter, setFilter] = useState(false);
  const filterToggle = () => {
    setFilter((prev) => !prev);
  };

  // Basic Search 
  function handleSearch(value) {
    if (value === "") {
      setFilteredList(list)
    } else {
      const filteredFranchises = list.filter((franchise) => {
        return franchise.franchiseName.toLowerCase().includes(value.toLowerCase())
      })
      setFilteredList(filteredFranchises)
    }
  }

  return (
    <div className="px-4">
      <div className='bg-white dark:bg-DTableBg flex flex-row justify-between sm:items-center gap-3 border-radius-top table-top-padding'>
        <h4 className='text-xl md:text-2xl font-semibold'>Franchise List</h4>
        <div className="flex flex-col sm:flex-row justify-between items-center sm:gap-[12px]">
          {/*<div className='flex sm:justify-end sm:items-center gap-5'>
            <button
              onClick={filterToggle}
              className={`hidden md:block ${isFilter ? "btn-secondary" : "btn-secondary rounded-[1.25rem]"
                }  px-5 py-2 rounded cursor-pointer rounded-[1.25rem]`}
              type='submit'>
              {isFilter ? (
                <span className='flex justify-center items-center gap-2'>
                  <AiOutlineClose /> Close
                </span>
              ) : (
                <span className=''>Filter</span>
              )}
            </button>
             {!isFilter ? (
              <CrmSearch paginatedThunk={loadAllTaskPaginated} />
            ) : (
              <div className='flex text-md'>
              </div>
            )}
          </div>*/}
          <div>
            <button className="py-2 px-3 md:px-6 btn-primary cursor-pointer flex items-center gap-2">
              <NavLink to='/admin/franchise/create' className={'flex items-center gap-2'}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="plus-icon">
                  <path stroke="white" fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
                </svg>
                <span className="text-white text-[10px] md:text-[14px] font-semibold">New Franchise</span>
              </NavLink>
            </button>
          </div>
        </div>
      </div>
      <div className='ant-card rounded card-wrapper border-radius-bottom table-inner-padding'>
        {filteredList && (
          <div className='flex justify-start mr-4 w-full'>
            <div className='flex flex-col sm:flex-row lg:items-center justify-between gap-2 my-4 w-full '>
              <div className="flex items-center sm:justify-start sm:gap-2">
                <CsvLinkBtn className="btn-secondary text-white w-max text-sm hover:bg-[#FFCDCB]">
                  <CSVLink
                    data={filteredList?.map(({ product, designationHistory, discount, holiday, ...rest }) => ({ ...rest }))}
                    className='flex items-center gap-2 font-normal text-[10px] md:text-[14px] text-[#E5383B] font-semibold'
                    filename='franchises-list'
                  >
                    <img src={downloadLogo} />
                    Download CSV
                  </CSVLink>
                </CsvLinkBtn>
                {filteredList && (
                  <div>
                    <ColVisibilityDropdown
                      options={columns}
                      columns={columns}
                      columnsToShowHandler={columnsToShowHandler}
                    />
                  </div>
                )}
              </div>
              {/* <div>
                <form>
                  <input placeholder="Search" className="py-1 px-3 border rounded-md focus-visible:outline-none" />
                </form>
              </div> */}
              <div>
                <CrmSearch handleSearch={handleSearch} />
              </div>
            </div>

            {/* <div>
              <Segmented
                className='text-center rounded text-red-500'
                size='middle'
                options={[
                  {
                    label: (
                      <span>
                        <i className='bi bi-person-lines-fill'></i> Active
                      </span>
                    ),
                    value: "true",
                  },
                  {
                    label: (
                      <span>
                        <i className='bi bi-person-dash-fill'></i> Inactive
                      </span>
                    ),
                    value: "false",
                  },
                ]}
                value={status}
                onChange={onChange}
              />
            </div> */}
          </div>
        )}
        <Table
          scroll={{ x: true }}
          loading={isFetchingFranchises}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true, // Allow changing page size  
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          columns={columnsToShow}
          dataSource={filteredList ? addKeys(filteredList) : []}
          className="user-table"
          rowClassName={(record, index) =>
            index % 2 === 0 ? "even-row" : "odd-row"
          }
        />
      </div>
      <ConfirmModal
        title="Delete Franchise"
        loading={isDeleting}
        message="Are you sure you want to delete this franchise?"
        open={isModalOpen}
        handleCloseModal={() => setIsModalOpen(false)}
        handleOk={handleOk}
        handleCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
      />
    </div>
  );
}

const Franchises = (props) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.franchise.list);

  useEffect(() => {
    dispatch(getAllFranchises({ status: "true" }));
  }, []);

  return (
    <UserPrivateComponent permission={"readAll-user"}>
      <div className='card card-custom mb-4'>
        <div className='card-body'>
          <CustomTable list={list} />
        </div>
      </div>
    </UserPrivateComponent>
  );
};

export default Franchises;
